module.exports = __webpack_public_path__ + "img/thumb-006-03.35ccdba0.png";